import type { CanvasTileStyle, TenantUiSettings } from "./tenantUi.types";

export const DEFAULT_CANVAS_TILE_STYLE: CanvasTileStyle = "grid";

/** Anything but a known value (missing, null, unknown string) falls back to the default. */
export const toCanvasTileStyle = (value: unknown): CanvasTileStyle =>
  value === "grid" || value === "cards" ? value : DEFAULT_CANVAS_TILE_STYLE;

export const toTenantUiSettings = (raw: unknown): TenantUiSettings => {
  const body = typeof raw === "object" && raw !== null ? (raw as Record<string, unknown>) : {};
  return {
    canvasTileStyle: toCanvasTileStyle(body.canvas_tile_style),
    oldArchitecture: body.old_architecture === true,
  };
};
